import { createSlice } from "@reduxjs/toolkit"

interface RolesAndPermsState {
    roles: Array<any>,
    roleCategories: Array<any>,
    perms: Array<any>,
    userPerms: Array<any>
}

const initialState: RolesAndPermsState = {
    roles: [],
    roleCategories: [],
    perms: [],
    userPerms: []
}

const rolesAndPermsSlice = createSlice({
    name: "rolesAndPerms",
    initialState,
    reducers: {
        setRoles: (state, action) => {
            state.roles = action.payload
        },
        setRoleCategories: (state, action) => {
            state.roleCategories = action.payload
        },
        setPerms: (state, action) => {
            state.perms = action.payload
        },
        setUserPerms: (state, action) => {
            state.userPerms = action.payload
        },
        expandCategory: (state, action) => {
            state.perms.find(module => module.module_name === action.payload).open = true;
        },
        collapseCategory: (state, action) => {
            state.perms.find(module => module.module_name === action.payload).open = false;
        },
    }
})

export default rolesAndPermsSlice.reducer
export const { setRoles, setRoleCategories, setPerms, setUserPerms, expandCategory, collapseCategory } = rolesAndPermsSlice.actions;

// {
//     id: "metricbm",
//     name: "Metric Blueprint",
//     enable: false,
//     type: "macro",
//     open: false,
//     entities: [{
//         id: "metricbm_add",
//         name: "Metric Blueprint Add",
//         enable: false,
//         type: "micro"
//     },
//     {
//         id: "metricbm_edit",
//         name: "Metric Blueprint Edit",
//         enable: false,
//         type: "micro"
//     },
//     {
//         id: "metricbm_delete",
//         name: "Metric Blueprint Delete",
//         enable: false,
//         type: "micro"
//     },
//     {
//         id: "metricbm_view",
//         name: "Metric Blueprint View",
//         enable: true,
//         type: "micro"
//     },]
// },
// {
//     id: "metricg",
//     name: "Metric Goals",
//     enable: false,
//     open: false,
//     type: "macro",
//     entities: [{
//         id: "metricbm_add",
//         name: "Metric Goals Add",
//         enable: true,
//         type: "micro"
//     },
//     {
//         id: "metricbm_edit",
//         name: "Metric Goals Edit",
//         enable: false,
//         type: "micro"
//     },
//     {
//         id: "metricbm_delete",
//         name: "Metric Goals Delete",
//         enable: false,
//         type: "micro"
//     },
//     {
//         id: "metricbm_view",
//         name: "Metric Goals View",
//         enable: true,
//         type: "micro"
//     },]
// },